<template>
    <div class="container">
      <QueryFrame
        @handlePage='handlePage'
        @handlePageSize='handlePageSize'
        :count='count'
        :current="page"
      >
        <div slot="queryParams" class="form">
          <div class="queryContainer">
            <div class="queryItem">
              <label>商品搜索:</label>
              <lk-input placeholder='请输入商品编码/通用名/商品名' class="item" clearable v-model.trim="params.nameMix"></lk-input>
            </div>
            <div class="queryItem">
              <label>肿瘤药物分类:</label>
              <lk-select v-model="params.antitumorType" style="width:200px" clearable>
                <lk-option v-for="(item,index) in classList" :key="index" :value='item.id'>{{item.name}}</lk-option>
              </lk-select>
            </div>
            <div class="queryItem">
              <lk-button class="mr" type='primary' @click="searchData">查询</lk-button>
              <lk-button @click="clear">重置</lk-button>
            </div>
          </div>
        </div>
        <div slot="table">
          <div class="btns">
            <lk-button class="mr8" type='primary' v-if="handlePermission('tumourDrugAdd')" @click="addNewDrug">+新增肿瘤药物</lk-button>
            <lk-button class="mr8" type='primary' v-if="handlePermission('tumourDrugBatchAdd')" @click="toBatchAdd">批量导入</lk-button>
            <DownloadButton @on-click='exportExcel' v-if="handlePermission('tumourDrugListDownload')"></DownloadButton>
          </div>
          <lk-table
            border
            :columns='columns'
            :data='tableData'
          />
        </div>
      </QueryFrame>
      <lk-modal
            v-model="addModal"
            :title="addDrugTitle"
            :width="850"
            :mask-closable='false'
            @on-cancel="handleCancelSelection"
            >
            <div>
                <div :gutter="16" class="queryParams mb8" v-if="addDrugTitle == '新增肿瘤药物'">
                    <div style="display:flex">
                        <span style="margin-left: 25px; margin-top: 6px">选择药品：</span>
                        <drugInput ref="goodsSearch" @selected='addGoods' style="width:256px" :autoFocus='true'>
                        </drugInput>
                    </div>
                </div>
                <lk-table class='mb8 leftBorder mr8' :data='drugList' :columns='drugCol' border></lk-table>
                <div style="display:flex">
                    <span style="margin-top: 6px">肿瘤药物分类：</span>
                    <lk-select v-model="antitumorType" style="width:200px" filterable>
                        <lk-option v-for="(item,index) in classList" :key="index" :value='item.id'>{{item.name}}</lk-option>
                    </lk-select>
                </div>
            </div>
            <div class="modalFooter" slot="footer">
                <lk-button type='primary' @click='handleSelection'>{{addDrugTitle == '新增肿瘤药物' ? '添加' : '保存'}}</lk-button>
                <lk-button @click='handleCancelSelection'>取消</lk-button>
            </div>
        </lk-modal>
        <!-- // 导入模板 -->
        <lk-modal v-model="showUploadAlert"
            :footer-hide='true'
            title="批量导入"
            width="400"
            @on-cancel="upCancel">
            <div class="uploadContainer">
            <div class="subTitle">
                <span class="word">导入模板：</span>
            </div>
            <div class="uploadContent">
                <div class="uploader" @click="$refs.file.click()">
                <input type="file" ref="file" @change="fileReader" v-show="false">
                <p>
                    <lk-icon type="ios-cloud-upload-outline" size="16"></lk-icon>点击上传
                </p>
                </div>
            <div style="margin-top:12px;" v-if="this.file">
                {{`上传的文件是:${this.file.name || ''}`}}
            </div>
                <span class="font14">请先<a @click="downLoad('https://linkdoc-erp.oss-cn-beijing.aliyuncs.com/erp-uid-3063/652212271427.xlsx?Expires=3227322427&OSSAccessKeyId=LTAIhQ088Y2NYQem&Signature=8gxn9bHUFTygGo1ELgIa01ZJ0pc%3D', '肿瘤药分类批量导入模板.xlsx')">下载导入模板</a> ，编辑无误后上传文件</span>
            </div>
            <div class="buttons">
                <lk-button type='primary' class="cancel" @click="unCheckUploadFile" :disabled="!file">确定上传</lk-button>
                <lk-button @click="upCancel" >取消</lk-button>
            </div>
            </div>
        </lk-modal>
        <!-- 最后确认弹框 -->
        <lk-modal v-model="showAffirmModal"
            :footer-hide='true'
            title="导入校验"
            width="400"
            @on-cancel="importCancel">
            <div class="uploadContainer">
                <div class="subTitle">
                    <span class="iconfont info">&#xe613;</span>
                    <h1 class="warnTitle">数据校验成功，是否确认导入</h1>
                </div>
                <div class="warnContentTitle">如果导入商品与已添加商品重复，将按导入表数据进行更新</div>
                <lk-checkbox class="warnContentTitle" v-model="isDelete"> 删除本次导入数据之外的肿瘤药分类设置</lk-checkbox>
                <div v-if="isDelete" style="margin-left:40px;color: red;">将只保留本次导入的肿瘤药分类信息，请谨慎操作</div>
                <div class="buttons">
                    <lk-button type='primary' class="cancel" @click="checkUploadFile">确认</lk-button>
                    <lk-button @click="importCancel" >取消</lk-button>
                </div>
            </div>
        </lk-modal>
        <lk-modal v-model="showErrorAlert"
        :footer-hide='true'
        title="导入校验"
        width="400"
        >
          <div class="errorListContainer">
            <div class="subTitle">
              <span
                  :class="{
                      'iconfont':true,
                      'alert':true,
                  }">&#xe613;
              </span>
              <span class="word">导入失败</span>
            </div>
            <div class="content">
              <span class="contentList" v-for="item in errorList" :key="item">
                  {{item}}
              </span>
            </div>
            <div class="btns">
              <lk-button type='primary' @click="hiddenErrorView">确定</lk-button>
            </div>
          </div>
        </lk-modal>
    </div>
  </template>
<script>
import Axios from 'axios';
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import mapState from '../../../mixins/mapState';
import queryMixins from '../../../mixins/queryMixins';
import tools from '../../../services/tools';
import utils from '../../../libs/utils';
import drugInput from './DrugSearchInput.vue';
import DTPListModal from '../../../components/DTPListModal.vue';
import DownloadButton from '../../../components/download/DownloadButton.vue';

export default {
  name: 'InteractionList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    drugInput,
    DTPListModal,
    DownloadButton,
  },
  computed: {
    selectedTempGoodsIds() {
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item);
      });
      return result;
    },
  },
  data() {
    return {
      inputKey: '',
      addDrugTitle: '',
      hideFooter: true,
      isDelete: false,
      file: '',
      errorList: [],
      showErrorAlert: false,
      showUploadAlert: false,
      showAffirmModal: false,
      antitumorType: 0,
      classList: [
        { name: '靶向药物', id: 1 },
        { name: '化疗药物', id: 2 },
        { name: '抗血管药物', id: 3 },
        { name: '抗肿瘤辅助用药', id: 4 },
        { name: '内分泌用药', id: 5 },
        { name: '免疫药物', id: 6 },
      ],
      drugList: [],
      drugCol: [
        { title: '商品编码', key: 'drugSerialCode', width: 90 },
        { title: '商品通用名', key: 'approvedDrugNames', minWidth: 120 },
        { title: '商品名', key: 'goodsName', minWidth: 120 },
        { title: '规格', key: 'specifications', width: 90 },
        { title: '生产企业', key: 'manufacturer', minWidth: 130 },
        { title: '单位', key: 'drugMiniPackageUnitString', width: 80 },
      ],
      drugSearchKey: '',
      addModal: false,
      sharedRateList: [
        {
          id: 1,
          name: '关注',
        },
        {
          id: 2,
          name: '不推荐合用',
        },
        {
          id: 3,
          name: '谨慎合用',
        },
        {
          id: 4,
          name: '禁忌合用',
        },
      ],
      isShow: false,
      loading: false,
      file: '',
      tableData: [],
      count: 0,
      page: 1,
      columns: [
        { title: '序号', type: 'index', width: 70 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 90 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 110 },
        { title: '商品名', key: 'goodsName', minWidth: 110 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 110 },
        { title: '批准文号', key: 'approvalNumber', minWidth: 130 },
        { title: '肿瘤药物分类', key: 'antitumorTypeName', minWidth: 110 },
        { title: '最后编辑时间', key: 'operateTime', minWidth: 130 },
        { title: '操作人', key: 'operatorName', width: 110 },
        {
          title: '操作',
          width: 105,
          fixed: 'right',
          render: (h, params) => h('div', [
            this.handlePermission('tumourDrugEdit') && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.editGoods(params.index);
                },
              },
            }, '修改'),
            this.handlePermission('tumourDrugDelete') && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.deleteDrug(params.index);
                },
              },
            }, '删除'),
          ]),
        },
      ],
    };
  },
  methods: {
    exportExcel() {
      const tempP = utils.deepClone(this.params);
      tempP.queryCondition = utils.getQueryCondition('.queryContainer');
      tools.exportDrugList(tempP).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNewDrug() {
      this.addDrugTitle = '新增肿瘤药物';
      this.antitumorType = 0;
      this.drugList = [];
      this.addModal = true;
    },
    importCancel() {
      this.file = '';
      this.showAffirmModal = false;
    },
    upCancel() {
      this.file = '';
      this.showUploadAlert = false;
    },
    hiddenErrorView() {
      this.showErrorAlert = false;
    },
    deleteDrug(index) {
      this.$Modal.confirm({
        title: '是否确认删除？',
        cancelText: '取消',
        okText: '确认',
        onOk: () => {
          tools.deleteTumourDrug({ goodsBaseId: this.tableData[index].id }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('删除成功');
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        },
      });
    },
    editGoods(index) {
      this.addModal = true;
      this.addDrugTitle = '修改肿瘤药物';
      const temp = utils.deepClone(this.tableData[index]);
      this.drugList = [temp];
      this.antitumorType = temp.antitumorType;
    },
    addGoods(val) {
      const temp = utils.deepClone(val);
      temp.drugSerialCode = temp.goodsBase.drugSerialCode;
      temp.approvedDrugNames = temp.goodsBase.approvedDrugNames;
      temp.goodsName = temp.goodsBase.goodsName;
      temp.specifications = temp.goodsBase.specifications;
      temp.manufacturer = temp.goodsBase.manufacturer;
      temp.drugMiniPackageUnitString = temp.goodsBase.drugMiniPackageUnitString;
      temp.id = temp.goodsBase.id;
      this.drugList = [temp];
    },
    handleSelection() {
      if (this.drugList.length <= 0) {
        this.$Message.error('请选择药物');
        return;
      }
      if (this.antitumorType * 1 <= 0 || !this.antitumorType) {
        this.$Message.error('请选择分类');
        return;
      }
      const tempParams = { goodsBaseId: this.drugList[0].id, antitumorType: this.antitumorType };
      let successTitle = this.addDrugTitle == '新增肿瘤药物' ? '添加成功' : '修改成功';
      tools.submitTumourDrug(tempParams).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success(successTitle);
          this.addModal = false;
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleCancelSelection() {
      this.antitumorType = 0;
      this.drugList = [];
      this.addModal = false;
      if (this.addDrugTitle == '新增肿瘤药物') {
        this.$refs.goodsSearch.clearValue()
      }
    },
    downLoad(url, name) {
      Axios.get(url, {
        responseType: 'blob',
      }).then((res) => {
        if (!res) {
          this.$Message.error('获取导入模版失败，请稍后重试');
        }
        utils.downFile(res.data, name);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toBatchAdd() {
      this.showUploadAlert = true;
    },
    fileReader(e) {
      this.loading = true;
      if (e.target.files.length > 0 && e.target.files[0].size > 1024 * 1024) { // 1M 
        this.$Message.error(`文件超过1M限制，请更换文件`);
        return;
      }
      this.file = e.target.files[0];
      e.target.value = null;
    },
    batchCancel() {
      this.file = '';
    },
    searchData() {
      this.page = 1;
      this.params.page = 1;
      this.params.size = this.size;
      const params = utils.deepClone(this.params);
      tools.getTumourList(params).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          this.count = data.count;
          data.list.forEach((item) => {
            item.operateTime = utils.formatDateToSecond(item.operateTime);
          });
          this.tableData = data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      tools.getTumourList(this.params).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          this.count = data.count;
          data.list.forEach((item) => {
            item.operateTime = utils.formatDateToSecond(item.operateTime);
          });
          this.tableData = data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.params = {};
    },
    unCheckUploadFile() { // 第一次提交
      this.showUploadAlert = false;
      const form = new FormData();
      form.append('file', this.file);
      this.uploadFile(form, true);
    },
    checkUploadFile() {
      this.showAffirmModal = false;
      const form = new FormData();
      form.append('file', this.file);
      form.append('confirm', 1);
      form.append('deleteOthers', this.isDelete ? 1 : 2);
      this.uploadFile(form, false);
    },
    uploadFile(params, isFirst) {
      tools.batchTumourDrug(params).then((res) => {
        if (res.data.status === 200) {
          if (isFirst) {
            this.isDelete = false;
            this.showAffirmModal = true;
          } else {
            this.$Message.success('导入成功');
            this.file = '';
            this.getData();
          }
          this.isDelete = false;
        } else if (res.data.status == 44003) {
          this.showError(res.data.data);
        } else {
          this.showError([res.data.error]);
        }
      }).catch((err) => {
        if (err.status == 44003) {
          this.showError(err.data);
        } else {
          this.showError([err.error]);
        }
      });
    },
    showError(list) {
      this.file = '';
      this.isDelete = false;
      this.errorList = list;
      this.showErrorAlert = true;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
  <style lang="less" scoped>
    .btns {
      margin-bottom: 12px;
    }
    .flex {
      display: flex;
      align-items: center;
    }
    .margin-left {
      margin-left: 12px;
    }
    .margin-bottom {
      margin-bottom: 12px;
    }
    .select {
      width: 200px;
    }
    .uploader {
      height: 28px;
      width: 87px;
      border: 1px dashed #dedede;
      text-align: center;
      position: relative;
      cursor: pointer;
      line-height: 1.2;
      p {
        line-height: 28px;
        font-size: 12px
      }
    }
    .leftBorder {
        left: 85px;
        margin-right: 90px
    }
    .uploadContainer {
        position: relative;
        height: 130px;
    }
    .subTitle{
        display: flex;
        align-items: left;
        .icon{
            margin-right: 16px;
            color: #1890FF
        }
        .alert{
            color: orange;
        }
        .info{
            color: #1890FF
            // color: #FF4D07
        }
        .word{
            font-size: 12px;
            color: rgba(0,0,0,0.75);
            margin-left: 8px
        }
    }
    .title {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .word{
            font-size: 14px;
            color: rgba(0,0,0,0.75);
            margin-left: 8px
        }
    }
    .uploadContent{
        display: flex;
        justify-content: flex-start;
        position: absolute;
        flex-direction: column;
        top: 1px;
        left: 80px;
    }
    .buttons{
        display: flex;
        justify-content: flex-end;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 136px;
        .cancel{
            margin-right: 16px
        }
    }
    .warnTitle {
        font-size: small;
        margin-left: 6px;
        margin-top: 2px;
    }
    .warnContentTitle {
        margin-left: 23px;
        margin-top: 4px;
    }

    .errorListContainer {
//   height: 136px;
  position: relative;
  .btns{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 136px;
  .cancel{
    margin-right: 16px
  }
  }
  .title {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .word{
      font-size: 14px;
      color: rgba(0,0,0,0.75);
      margin-left: 8px
    }
  }
  .subTitle{
    display: flex;
    align-items: left;
    .icon{
      margin-right: 16px;
      color: #1890FF
    }
    .alert{
      color: orange;
    }
    .info{
      color: #1890FF
      // color: #FF4D07
    }
    .word{
      font-size: 14px;
      color: rgba(0,0,0,0.75);
      margin-left: 8px
    }
  }
    .content{
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      padding: 0 0 0 10px;
      width: 100%;
      max-height: 300px;
      overflow: auto;
      border-bottom: 50px solid white;
    }
    .line {
      height: 1px;
      background-color: black;
    }
    .contentList {
      padding-left: 15px;
      flex-wrap: wrap;
    }
  }
</style>
